import { createSelector } from 'reselect'

const selector = state => state.profileReducer

export const changePasswordSelector = createSelector(
  [selector],
  ({
    changePassword,
    changePasswordError,
    changePasswordLoading
  }) => ({
    changePassword,
    changePasswordError,
    changePasswordLoading
  })
)

export const userInformationSelector = createSelector(
  [selector],
  (userInformation) => userInformation
)
